import { render, staticRenderFns } from "./StockCard.vue?vue&type=template&id=3664e53e&"
import script from "./StockCard.vue?vue&type=script&lang=js&"
export * from "./StockCard.vue?vue&type=script&lang=js&"
import style0 from "./StockCard.vue?vue&type=style&index=0&class=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports